import { apiGateway } from "@/_old/services/api-gateway";

export const resendEmailVerificationApi = async () => {
  const { data } = await apiGateway.post(`/api/v0/auth`, {});

  return {
    data,
  };
};
